module.exports = __webpack_public_path__ + "img/2-800x800.4fe75c6e.png";